import { AppMenuItem } from 'components/uikit/menu/AppMenu';
import { useScopedTranslation } from 'application/localization/useScopedTranslation';
import { DocumentDeletionBlockReason } from 'services/api/api-client';
import { FolderDeletionBlockReason } from 'helpers/documents/types/base.ts';
import styles from '../DocumentListItem.module.scss';

export type DeletionBlockReason =
  | DocumentDeletionBlockReason
  | FolderDeletionBlockReason
  | undefined;

export const useTreeItemMenuItems = () => {
  const i18n = useScopedTranslation(
    'Page.Projects.ProjectDetailsPage.FoldersTree.TreeItem',
  );

  const getDeleteTooltip = (
    deletionBlockReason: DeletionBlockReason,
  ): string | undefined => {
    switch (deletionBlockReason) {
      case DocumentDeletionBlockReason.HasActiveEditors:
        return i18n.t('delete_document_being_edited_message');
      case DocumentDeletionBlockReason.HasDerivedDocuments:
        return i18n.t('delete_document_with_derived_message');
      case FolderDeletionBlockReason.HasBlockedChildren:
        return i18n.t('delete_folder_with_blocked_children_message');
      default:
        return undefined;
    }
  };

  const createDeleteMenuItem = (params: {
    disabled: boolean;
    deletionBlockReason: DeletionBlockReason;
    hidden: boolean;
    onClick: () => void;
  }): AppMenuItem => ({
    key: 'delete',
    text: i18n.t('delete_button'),
    className: styles.delete,
    disabled: params.disabled,
    tooltipMessage: getDeleteTooltip(params.deletionBlockReason),
    onClick: params.onClick,
    hidden: params.hidden,
  });

  const createEditMenuItem = (params: {
    lockReason?: string | null;
    hidden: boolean;
    onClick: () => void;
  }): AppMenuItem => ({
    key: 'edit',
    text: i18n.t('edit_button'),
    className: styles.menuItem,
    onClick: params.onClick,
    disabled: !!params.lockReason,
    hidden: params.hidden,
    tooltipMessage: params.lockReason,
  });

  return { createDeleteMenuItem, createEditMenuItem };
};
